<template lang="pug">
  div
    v-toolbar.primary.display-1(
      dark
      style="height: 80px;"
      ).d-flex.align-center
      span PRODUCTO:  
        b {{_product.name}}
    v-card.pa-4
      v-layout(wrap)
        v-flex.xs12.d-flex.justify-center.text-xs-center.display-3.py-3(v-if="!offerPrice")
          span
            span PRECIO: 
            b {{_product.base_price | mixFormatCurrency}}
        v-flex.xs12.d-flex.justify-center.text-xs-center.display-3.pt-3(v-if="offerPrice")
            .text-xs-center.d-flex(style="flex-direction: column;")
              span.display-1 ANTES: {{_product.base_price | mixFormatCurrency}}
              span
                b PRECIO OFERTA: 
                b {{parseInt(offerPrice) | mixFormatCurrency}}
        v-flex.xs12.display-1.pt-3.text-xs-center.pt-4.mt-4(v-if="wholesaleDiscounts")
          span.display-1.font-weight-bold Descuentos por mayor
          v-list
            v-list-tile.primary.white--text.mt-4
              v-layout
                v-flex.xs6
                  span.title UNIDADES
                v-flex.xs6
                  span.title DESCUENTO
            v-divider
            template(v-for="(wdc, idx) in wholesaleDiscounts")
              v-layout.pa-3
                v-flex.xs6
                  span.title {{wdc.quantity}}
                v-flex.xs6
                  span.title  {{wdc.discount}}
              v-divider
</template>

<script>
import { cloneDeep } from 'lodash'
import ProductHelper from '../../services/API/helpers/ProductHelper'
import CurrencyUtils from '../../mixins/CurrencyUtils'
export default {
    mixins: [CurrencyUtils],
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
    computed: {
        _product() {
            return ProductHelper.frontendProduct(cloneDeep(this.product))
        },
        offerPrice() {
            return this._product.virtual_offer_price
                ? this._product.virtual_offer_price.offer_price || null
                : null
        },
        wholesaleDiscounts() {
            if (this.offerPrice) return null
            if (
                !this._product.wholesaleDiscounts ||
                !this._product.wholesaleDiscounts.length
            )
                return null
            return this._product.wholesaleDiscounts
                ? this._product.wholesaleDiscounts
                      .sort((a, b) => a.quantity_discount - b.quantity_discount)
                      .map(wdc => ({
                          quantity: wdc.quantity_discount,
                          discount: wdc.unit_price_discount
                              ? `$ ${this.mixCurrencyFormatter(
                                    wdc.unit_price_discount
                                )}`
                              : `${wdc.percentage_discount}%`,
                      }))
                : null
        },
    },
}
</script>
